// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TextArea__Wrapper_1fkNu","_active":"TextArea___active_1OWkT","_error":"TextArea___error_3nimX"};